module.exports = __webpack_public_path__ + "img/case-logo-5.2e14a1d7.png";